export const formatDateForInput = (dateValue: Date | string | undefined): string => {
  if (!dateValue) return '';
  
  // Create a date object
  let date: Date;
  if (typeof dateValue === 'string') {
    // If it's a string, parse it as a local date to avoid timezone issues
    const parts = dateValue.split('T')[0].split('-'); // Get just the date part
    date = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
  } else {
    date = new Date(dateValue);
  }
  
  // Format as YYYY-MM-DD for HTML date input
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};